import { styled } from "styled-components";

const InputTextStyled = styled.input`
  background: var(--bg);
  font: var(--body2-regular);
  padding-block: 0.5rem;
  padding-inline: 1rem;
  border: none;
  font: var(--body2-regular);
  border-radius: 0.5rem;
  border: 1px solid var(--grey-1);
  color: var(--white);
  flex: 1;
`;

export default InputTextStyled;
